/* Commercial cart tools: live-cart qualification and native Shopify quote dialog interaction. */
(function () {
  'use strict';

  var lastTrigger = null;
  var qualificationTimer = null;
  var QUOTE_THRESHOLD_CENTS = 1000000;
  var QUOTE_ITEM_THRESHOLD = 5;

  function closeDialog(dialog) {
    if (!dialog) return;
    if (dialog.open) dialog.close();
    document.documentElement.classList.remove('ctx-cart-quote-open');
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
  }

  function qualifyQuoteModule() {
    var modules = document.querySelectorAll('[data-ctx-cart-quote]');
    if (!modules.length) return;

    fetch('/cart.js')
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var qualifies = Number(cart.total_price || 0) >= QUOTE_THRESHOLD_CENTS
          || Number(cart.item_count || 0) >= QUOTE_ITEM_THRESHOLD;
        modules.forEach(function (module) {
          module.hidden = !qualifies;
          if (!qualifies) closeDialog(module.querySelector('[data-ctx-cart-quote-dialog]'));
        });
      })
      .catch(function () {
        /* Keep the module hidden when current cart evidence cannot be obtained. */
      });
  }

  function scheduleQualification() {
    window.clearTimeout(qualificationTimer);
    qualificationTimer = window.setTimeout(qualifyQuoteModule, 80);
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[data-ctx-cart-quote-open]');
    if (opener) {
      var dialog = document.querySelector('[data-ctx-cart-quote-dialog]');
      if (!dialog) return;
      lastTrigger = opener;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', 'open');
      document.documentElement.classList.add('ctx-cart-quote-open');
      var firstField = dialog.querySelector('input:not([type="hidden"]), textarea, button');
      if (firstField) window.setTimeout(function () { firstField.focus(); }, 0);
      return;
    }

    var closer = event.target.closest && event.target.closest('[data-ctx-cart-quote-close]');
    if (closer) closeDialog(closer.closest('[data-ctx-cart-quote-dialog]'));
  });

  document.addEventListener('click', function (event) {
    var dialog = event.target && event.target.matches && event.target.matches('[data-ctx-cart-quote-dialog]') ? event.target : null;
    if (dialog) closeDialog(dialog);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var dialog = document.querySelector('[data-ctx-cart-quote-dialog][open]');
    if (dialog) closeDialog(dialog);
  });

  document.addEventListener('cart:refresh', scheduleQualification);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleQualification);
  else scheduleQualification();
})();
